import { Reveal, Overline } from "./Reveal";
import { Check, Banknote, CreditCard, Smartphone, FileText } from "lucide-react";

const INCLUDED = [
  "Full pre-treatment consultation & evaluation",
  "Complete tailored full-body sports massage",
  "Personalized aftercare guidance & stretches",
  "Recommended treatment plan for your horse",
];

const PAYMENTS = [
  { label: "Cash", icon: Banknote },
  { label: "Check", icon: FileText },
  { label: "Credit", icon: CreditCard },
  { label: "Zelle", icon: Smartphone },
  { label: "Venmo", icon: Smartphone },
];

export const Pricing = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="pricing" data-testid="pricing-section" className="py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <Overline>Pricing</Overline>
          <h2 className="mt-5 font-heading text-4xl md:text-5xl font-light tracking-tight text-charcoal leading-tight">
            Simple, transparent pricing
          </h2>
          <p className="mt-6 text-stone text-lg font-light leading-relaxed">
            One complete treatment, tailored to your horse — no hidden extras.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Main price card */}
          <Reveal className="lg:col-span-7">
            <div data-testid="price-card-massage" className="h-full bg-charcoal text-sand rounded-[2rem] p-10 md:p-12 shadow-lg">
              <span className="text-xs uppercase tracking-[0.25em] text-clay">Full Body Massage</span>
              <div className="mt-6 flex items-end gap-2">
                <span className="font-heading text-7xl md:text-8xl font-light leading-none">$125</span>
                <span className="text-sand/60 mb-2">per session</span>
              </div>
              <ul className="mt-8 space-y-3">
                {INCLUDED.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sand/85 font-light">
                    <Check size={20} strokeWidth={1.5} className="text-clay shrink-0 mt-0.5" /> {item}
                  </li>
                ))}
              </ul>
              <button
                data-testid="pricing-book-button"
                onClick={() => go("book")}
                className="mt-10 bg-clay text-sand rounded-full px-8 py-4 font-medium transition-all duration-300 hover:bg-clay-dark hover:-translate-y-1 shadow-sm"
              >
                Request an appointment
              </button>
            </div>
          </Reveal>

          {/* Side: farm call + payments */}
          <div className="lg:col-span-5 flex flex-col gap-6">
            <Reveal delay={0.1}>
              <div data-testid="price-card-farmcall" className="bg-sand-dark rounded-[2rem] p-8 md:p-10 border border-charcoal/5">
                <span className="text-xs uppercase tracking-[0.25em] text-clay">Travel</span>
                <p className="mt-4 font-heading text-3xl text-charcoal">+ $50 farm call</p>
                <p className="mt-3 text-stone font-light leading-relaxed">
                  Added only when travel to your barn exceeds one hour. Anything within an hour is included at no extra charge.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div data-testid="payment-methods" className="bg-sand-dark rounded-[2rem] p-8 md:p-10 border border-charcoal/5">
                <span className="text-xs uppercase tracking-[0.25em] text-clay">Accepted payment</span>
                <div className="mt-5 flex flex-wrap gap-3">
                  {PAYMENTS.map(({ label, icon: Icon }) => (
                    <span
                      key={label}
                      data-testid={`payment-${label.toLowerCase()}`}
                      className="inline-flex items-center gap-2 bg-sand rounded-full px-4 py-2.5 text-sm text-charcoal border border-charcoal/5"
                    >
                      <Icon size={16} strokeWidth={1.5} className="text-clay" /> {label}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
